import { BodyRow, EditedRow, HeadField } from "../types/table-data.types";

export type PrimaryKeys = {
  key: string;
  index: number;
  value?: string;
};

export const getKeys = (
  config: { head: HeadField[][][]; primaryKey: string[][][] },
  at: { level: number; index: number },
  row: BodyRow
): PrimaryKeys[] => {
  const values = Array.isArray(row[0]) && Array.isArray(row[1]) ? (row[0] as string[]) : (row as string[]);

  return config.primaryKey[at.level][at.index]
    .map((key) => {
      const index = config.head[at.level][at.index].findIndex(([name]) => name === key);
      return {
        key,
        index,
        value: index >= 0 ? values[index] : undefined,
      };
    })
    .filter((entry) => entry.index >= 0);
};

const isPrimitiveArray = (value: unknown): value is Array<string | number | boolean | null> =>
  Array.isArray(value) && value.every((item) =>
    ["string", "number", "boolean", "object"].includes(typeof item)
  );

export const isNestedRow = (row: BodyRow, hasDetailHead: boolean): row is [string[], string[][]] =>
  hasDetailHead && Array.isArray(row) && Array.isArray(row[0]) && Array.isArray(row[1]) &&
  isPrimitiveArray(row[0]) && row[1].every(Array.isArray);

export const getMasterRow = (row: BodyRow):string[] =>
  isNestedRow(row, Array.isArray(row[0])) ? row[0] : row as string[];

export const getMasterRows = (rows: EditedRow[]):string[][] => rows.map(({ row }) =>
  isNestedRow(row, Array.isArray(row[0])) ? row[0] : row as string[]
);
  
